import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import Logo from 'components/common/app/logo';
import Avatar from 'components/common/app/avatar';
import Welcome from 'components/common/app/welcome';

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    handleBack(useWelcome) {
        const {history, locale} = this.props;

        const pageTranslates = locale.translation.Pages.App.Layout.Header;


        if (history.action == 'REPLACE' && history.location.pathname.split('/').pop() == 'home')
            if (useWelcome)
                return (<Welcome/>);
            else
                return;
        else if (history.location.pathname.split('/').pop().includes('paymentresult')) {
            return;
        }

        return (
            <div>
                <h3 className="greeting-text p-2" onClick={this.props.history.goBack}>
                    <i className="fa fa-arrow-left" aria-hidden="true" style={{padding: '0 10px', float: 'left'}}></i>
                    {/*Can use previous page name*/}
                    <span>
                        {pageTranslates.Back}
                    </span>
                </h3>
            </div>
        );
    }

    render() {
        const {history, avatar} = this.props;

        return (
            <>
                <div className="header header-fixed header-auto-show header-logo-app safe-area-view-top" style={{
                    direction: 'rtl',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row-reverse'
                }}>
                    <div>
                        {this.handleBack(false)}
                    </div>
                    <div>
                        <Logo height={50}/>
                    </div>
                </div>
                <div className="page-title page-title-large safe-area-view-top" style={{height: 80}}>
                    <div style={{float: 'left'}}>
                        {this.handleBack(true)}
                    </div>
                    <div style={{float: 'right'}}>
                        <Avatar src={avatar}/>
                    </div>
                </div>
                <div className='clearfix'></div>
                <div className="card header-card shape-rounded safe-area-view-top-height" style={{height: 160}}>
                    <div className="card-overlay app-container-header-background opacity-95"></div>
                </div>
            </>
        );
    }
}


const mapStateToProps = state => {
    const {locale, avatar} = state;
    return {locale, avatar};
};

export default connect(mapStateToProps, null)(withRouter(Header));
